import React, { useMemo, useRef, useState } from "react";
import { ListGroup } from "react-bootstrap";
import ExchangePill from "../ExchangePill";
import { parseDate } from "../../utils/dateformater";
import LoadingSpinner from "../FutureChain/LoadingSpinner";
import { ScripLookUpHitSource } from "../../hooks/api/get/getScripLookUp";
import { SearchArrayType } from "../Alerts/common/SearchResultsDropdown";
import { getSortName } from "../../utils/getShortName";
import "./virtualizedList.scss";
import { ScripSearchedData } from "../../models/symbolData";

const VirtualizedList = ({
  loading,
  items,
  itemHeight = 50,
  visibleHeight = 200,
  onItemSelect,
  searchType
}: {
  items: ScripSearchedData[];
  itemHeight?: number;
  visibleHeight?: number;
  onItemSelect: (item: any) => void;
  loading: boolean;
  searchType: SearchArrayType;
}) => {
  const [scrollTop, setScrollTop] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  // Calculate visible items based on scroll position
  const virtualizedItems = useMemo(() => {
    const startIndex = Math.floor(scrollTop / itemHeight);
    const endIndex = Math.min(
      startIndex + Math.ceil(visibleHeight / itemHeight) + 1,
      items.length
    );

    return items.slice(startIndex, endIndex).map((item, index) => ({
      item,
      index: startIndex + index,
      style: {
        position: "absolute",
        top: `${(startIndex + index) * itemHeight}px`,
        width: "100%",
        height: `${itemHeight}px`,
      },
    }));
  }, [items, scrollTop, itemHeight, visibleHeight]);

  // Handle scroll event
  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    setScrollTop(e.currentTarget.scrollTop);
  };

  return (
    <div
      ref={containerRef}
      className="overallSearch"
      style={{
        height: `${visibleHeight}px`,
        overflowY: "auto",
        position: "relative",
        borderRight:0
      }}
      onScroll={handleScroll}
    >
      <div
        style={{
          height: `${items.length * itemHeight}px`,
          position: "relative",
        }}
      >
       {
        loading ? <div className="text-center">
          <LoadingSpinner/>
        </div> : virtualizedItems.map(({ item, index, style }) => (
          <ListGroup.Item
            key={index}
            className="datarow overallSearch vl-border-bottom"
            style={{...style as React.CSSProperties, borderRight: 0, borderLeft: 0, borderTop: 0}}
            action
            onClick={() => onItemSelect(item)}
          >
            <div className="text-start d-flex  gap-2 ">
              <div className="NameLable">
                {getSortName(item?._source.sInstrumentName??'')}
              </div>
              <div>
                <div className="currentText">{item._source.sSymbol} <ExchangePill text={item?._source.sExchange} className="mx-1" /></div>
                <div className="">
                  <div className="currentText text_low currentText2">{item?._source.sSecurityDesc} {['OPT','FUT'].includes(getSortName(item?._source.sInstrumentName??'') ?? 'N/A') && parseDate(item?._source.nExpiryDate1??'')} {searchType === 'Options' && (parseFloat(item._source.nStrikePrice || '0') / 100)} {searchType === 'Options' && item._source.sOptionType}</div>
                  {/* {item.sSecurityDesc} */}
                </div>
              </div>
            </div>
          </ListGroup.Item>
        ))
       }
      </div>
    </div>
  );
};

export default VirtualizedList;
